export default {
  "site.name": "cssbuy.today",
  "site.tagline": "Melhor CSSBuy Spreadsheet 2026 em Português",
  "nav.categories": "Categorias",
  "nav.home": "Início",
  "nav.blog": "Blog",
  "hero.title_line1": "CSSBuy",
  "hero.title_line2": "Spreadsheet 2026",
  "hero.subtitle": "O guia mais completo em português para compras com agentes de shopping. Descubra as melhores lojas, compare preços e aprenda a economizar.",
  "hero.cta_spreadsheet": "cssbuy spreadsheet",
  "hero.cta_buy": "buy it now",
  "categories.heading_small": "navegue por",
  "categories.heading_line1": "Encontre Produtos",
  "categories.heading_line2": "Premium",
  "categories.view_all": "Ver Tudo",
  "categories.visit": "Visitar",
  "features.heading": "Por Que Este Spreadsheet?",
  "features.price_title": "Preços Atualizados",
  "features.price_desc": "Tabela com preços reais do mercado, atualizada semanalmente com as melhores ofertas do Taobao e Weidian.",
  "features.quality_title": "Qualidade Garantida",
  "features.quality_desc": "Cada produto é verificado por nossa equipe. Incluímos fotos QC, avaliações e notas de qualidade para cada item.",
  "features.guide_title": "Guia Completo",
  "features.guide_desc": "Do iniciante ao avançado. Aprenda como usar CSSBuy, evitar taxas alfandegárias e economizar em cada compra.",
  "features.safety_title": "Segurança Total",
  "features.safety_desc": "Dicas essenciais para comprar com segurança. Políticas de reembolso, proteção ao comprador e muito mais.",
  "about.heading": "O Guia Mais Completo",
  "about.description": "Criamos o melhor spreadsheet CSSBuy em português para ajudar compradores do Brasil e Portugal a encontrar produtos de qualidade com os melhores preços. Nossa tabela inclui mais de 500 produtos verificados, organizados por categoria, loja e avaliação de qualidade.",
  "about.tag_2026": "2026",
  "about.tag_taobao": "Taobao",
  "about.tag_weidian": "Weidian",
  "about.card_label": "Spreadsheet Premium",
  "about.card_title": "Acesso Ilimitado",
  "about.card_desc": "Tenha acesso à nossa planilha completa com atualizações mensais, novas lojas e produtos verificados pela comunidade.",
  "testimonials.heading": "O Que Dizem Os Usuários",
  "testimonial.quote": "\"Este spreadsheet mudou completamente a forma como faço compras no CSSBuy. Encontrei produtos que nunca teria descoberto sozinho. A tabela de comparação de agentes me fez economizar mais de 200€ em taxas de envio. Recomendo a todos que estão começando!\"",
  "testimonial.name": "Pedro Silva",
  "testimonial.role": "Comprador Verificado • São Paulo, Brasil",
  "testimonial.cta": "Verificar Spreadsheet",
  "cta.heading": "guia cssbuy atualizado",
  "cta.button": "Entrar no Site Principal",
  "cta.disclaimer_line1": "Site afiliado independente.",
  "cta.disclaimer_line2": "Links redirecionam para o site principal.",
  "footer.brand_desc": "Portal informativo sobre CSSBuy Spreadsheet. Guias, comparações e dicas para compradores de língua portuguesa.",
  "footer.column1_title": "Navegação",
  "footer.column2_title": "Categorias",
  "footer.column3_title": "Recursos",
  "footer.link_home": "Início",
  "footer.link_blog": "Blog",
  "footer.link_guide": "Guia CSSBuy",
  "footer.link_spreadsheet": "Spreadsheet",
  "footer.link_faq": "FAQ",
  "footer.link_security": "Segurança",
  "footer.link_shoes": "Shoes",
  "footer.link_hoodies": "Hoodies/Sweaters",
  "footer.link_tshirts": "T-Shirts",
  "footer.link_jackets": "Jackets",
  "footer.link_pants": "Pants/Shorts",
  "footer.link_headwear": "Headwear",
  "footer.link_sets": "Sets",
  "footer.link_accessories": "Accessories",
  "footer.link_bags": "Bags",
  "footer.copyright": "© CSSBuy.today 2026",
  "footer.rights": "Todos os direitos reservados.",
  "footer.newsletter_title": "Receba Atualizações",
  "footer.newsletter_desc": "Novas lojas e produtos toda semana.",
  "footer.newsletter_placeholder": "Seu melhor email",
  "footer.newsletter_button": "Inscrever",
  "article.back_home": "← Voltar ao Início",
  "seo.home_title": "CSSBuy Spreadsheet 2026 – Melhor Guia Completo em Português | cssbuy.today",
  "seo.home_desc": "Guia completo CSSBuy Spreadsheet 2026 em português. Aprenda como usar, compare agentes de shopping, descubra as melhores lojas Taobao e Weidian. Tabelas atualizadas, dicas de segurança e economia."
}